import axiosClient from "../../../../api/axiosClient";

const BASE_URL = "/api/trading/actual-dispatches";

const tradingActualDispatchService = {
  // Available items from an approved Dispatch Order
  getAvailableDispatchItems(dispatchOrderId) {
    return axiosClient.get(
      `${BASE_URL}/dispatch-order/${dispatchOrderId}/available-items`
    );
  },

  
  // Available batches for the selected material and warehouse.
  getAvailableBatches(materialId, warehouseId) {
    return axiosClient.get(`${BASE_URL}/available-batches`, {
      params: {
        material_id: materialId,
        warehouse_id: warehouseId,
      },
    });
  },
  
  
  // Actual Dispatch list
  getActualDispatchList(params = {}) {
    return axiosClient.get(`${BASE_URL}/`, { params });
  },

  // Actual Dispatch detail
  getActualDispatchDetail(actualDispatchId) {
    return axiosClient.get(`${BASE_URL}/${actualDispatchId}`);
  },

  // Create Actual Dispatch draft
  createActualDispatch(payload) {
    return axiosClient.post(`${BASE_URL}/`, payload);
  },

    // Update a Draft Actual Dispatch
  updateActualDispatch(actualDispatchId, payload) {
    return axiosClient.put(
      `${BASE_URL}/${actualDispatchId}`,
      payload
    );
  },
  
  // Confirm Actual Dispatch
  confirmActualDispatch(actualDispatchId) {
    return axiosClient.post(
      `${BASE_URL}/${actualDispatchId}/confirm`,
      {}
    );
  },
};

export default tradingActualDispatchService;